export const ROUTES = [
  {
    path: '/',
    component: () => import('@/layout/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/pages/Home.vue'),
        meta: {
          breadcrumb: [{ parent: 'Home', label: 'Home' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads',
        name: 'leads',
        component: () => import('@/views/pages/Leads.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Leads' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id',
        name: 'lead-details',
        component: () => import('@/views/pages/LeadDetails.vue'),
        meta: {
          roles: ['Admin', 'General Manager', 'Sales Director', 'Leadership Viewer', 'Sales Support', 'Controller', 'Registered User', 'Corporate Accounting']
        },
      },
      {
        path: 'leads/:id/progress_notes',
        name: 'progress-notes',
        component: () => import('@/views/pages/leadActions/ProgressNotes.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Progress Notes' }],
          roles: ['Admin']
        },
      },
      {
        path: 'leads/:id/opportunity_details',
        name: 'opportunity-details',
        component: () => import('@/views/pages/leadActions/OpportunityDetails.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Opportunity Details' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/edit',
        name: 'edit-lead',
        component: () => import('@/views/pages/leadActions/EditLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Edit' }],
          roles: ['Admin', 'General Manager', 'Sales Director', 'Sales Support'],
        },
      },
      {
        path: 'leads/:id/validate',
        name: 'validate-lead',
        component: () => import('@/views/pages/leadActions/ValidateLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Validate' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/invalidate',
        name: 'invalidate-lead',
        component: () => import('@/views/pages/leadActions/InvalidateLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Invalidate' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/revalidate',
        name: 'revalidate-lead',
        component: () => import('@/views/pages/leadActions/RevalidateLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Revalidate' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/redirect',
        name: 'redirect-lead',
        component: () => import('@/views/pages/leadActions/RedirectLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Redirect' }],
          roles: ['Admin', 'Sales Director', 'Sales Support'],
        },
      },
      {
        path: 'leads/:id/reject',
        name: 'reject-lead',
        component: () => import('@/views/pages/leadActions/RejectLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Reject' }],
          roles: ['Admin', 'Sales Director', 'Sales Support'],
        },
      },
      {
        path: 'leads/:id/reassign_brand',
        name: 'reassign-brand',
        component: () => import('@/views/pages/leadActions/ReassignBrand.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'ReassignBrand' }],
          roles: ['Admin', 'General Manager', 'Sales Director', 'Sales Support'],
        },
      },
      {
        path: 'leads/:id/reassign_user',
        name: 'reassign-user',
        component: () => import('@/views/pages/leadActions/ReassignUser.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'ReassignUser' }],
          roles: ['Admin', 'General Manager', 'Sales Director', 'Sales Support'],
        },
      },
      {
        path: 'leads/:id/assign',
        name: 'assign',
        component: () => import('@/views/pages/leadActions/AssignUser.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'AssignUser' }],
          roles: ['Admin', 'Sales Director', 'Sales Support'],
        },
      },
      {
        path: 'leads/:id/introduction',
        name: 'introduction',
        component: () => import('@/views/pages/leadActions/Introduction.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Introduction' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/opportunity',
        name: 'opportunity',
        component: () => import('@/views/pages/leadActions/Opportunity.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Opportunity' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/sold_reassign_user',
        name: 'sold-reassign-user',
        component: () => import('@/views/pages/leadActions/SoldReassignUser.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'SoldReassignUser' }],
          roles: ['Admin', 'General Manager', 'Sales Director', 'Sales Support'],
        },
      },
      {
        path: 'leads/:id/sale',
        name: 'sale-lead',
        component: () => import('@/views/pages/leadActions/SaleLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'SaleLead' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/ship',
        name: 'ship-lead',
        component: () => import('@/views/pages/leadActions/ShipLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'ShipLead' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/no_sale',
        name: 'no-sale-lead',
        component: () => import('@/views/pages/leadActions/NoSaleLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'NoSaleLead' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/confirm',
        name: 'confirm-lead',
        component: () => import('@/views/pages/leadActions/ConfirmLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'ConfirmLead' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/approve',
        name: 'approve-lead',
        component: () => import('@/views/pages/leadActions/ApproveLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'ApproveLead' }],
          roles: ['Admin', 'General Manager'],
        },
      },
      {
        path: 'leads/:id/disapprove',
        name: 'disapprove-lead',
        component: () => import('@/views/pages/leadActions/DisapproveLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'DisapproveLead' }],
          roles: ['Admin', 'General Manager'],
        },
      },
      {
        path: 'leads/:id/pay',
        name: 'pay-lead',
        component: () => import('@/views/pages/leadActions/PayLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'Pay' }],
          roles: ['Admin', 'Corporate Accounting'],
        },
      },
      {
        path: 'leads/:id/send_to_payroll',
        name: 'send-to-payroll-lead',
        component: () => import('@/views/pages/leadActions/SendToPayrollLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'SendToPayrollLead' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/abort',
        name: 'abort-lead',
        component: () => import('@/views/pages/leadActions/AbortLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'AbortLead' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/:id/unreject',
        name: 'unreject-lead',
        component: () => import('@/views/pages/leadActions/UnrejectLead.vue'),
        meta: {
          breadcrumb: [{ parent: 'Leads', label: 'UnrejectLead' }],
          roles: ['Admin'],
        },
      },
      {
        path: 'leads/leads_with_disabled_user',
        name: 'leads-with-disabled-user',
        component: () => import('@/views/pages/LeadsWithDisabledUser.vue'),
        meta: {
          roles: ['Admin']
        },
      },
      {
        path: 'leads/sold_leads_by_brand',
        name: 'sold-leads-by-brand',
        component: () => import('@/views/pages/SoldLeadsByBrand.vue'),
        meta: {
          roles: ['Admin']
        },
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('@/views/pages/User/Users.vue'),
        meta: {
          roles: ['Admin']
        },
      },
      {
        path: 'users/:id',
        name: 'user-details',
        component: () => import('@/views/pages/User/UserDetails.vue'),
        meta: {
          roles: ['Admin', 'General Manager', 'Sales Director', 'Leadership Viewer', 'Sales Support', 'Controller', 'Registered User', 'Corporate Accounting']
        },
      },
      {
        path: 'users/:id/dashboard',
        name: 'user-dashboard',
        component: () => import('@/views/pages/User/UserDashboard.vue'),
        meta: {
          roles: ['Admin', 'General Manager', 'Sales Director', 'Leadership Viewer', 'Sales Support', 'Controller', 'Registered User']
        },
      },
      {
        path: 'users/:id/mass_reassign',
        name: 'user-mass-reassign',
        component: () => import('@/views/pages/User/UserMassReassign.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'users/:id/edit',
        name: 'edit-user',
        component: () => import('@/views/pages/User/EditUser.vue'),
        meta: {
          roles: ['Admin', 'General Manager', 'Sales Director', 'Sales Support', 'Controller', 'Registered User', 'Corporate Accounting', 'MBUP'],
        },
      },
      {
        path: 'users/new',
        name: 'new-user',
        component: () => import('@/views/pages/User/NewUser.vue'),
        meta: {
          roles: ['Admin', 'General Manager', 'Sales Director', 'Sales Support'],
        },
      },
      {
        path: 'brands',
        name: 'brands',
        component: () => import('@/views/pages/Brand/Brands.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: ':brand_name',
        name: 'brand-dashboard',
        component: () => import('@/views/pages/BrandDashboard/BrandDashboard.vue'),
        meta: {
          roles: ['Admin', 'General Manager', 'Sales Director', 'Leadership Viewer', 'Sales Support', 'Controller'],
        },
      },
      {
        path: 'brands/:id/edit',
        name: 'edit-brand',
        component: () => import('@/views/pages/Brand/EditBrand.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'brands/new',
        name: 'new-brand',
        component: () => import('@/views/pages/Brand/NewBrand.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'categories',
        name: 'categories',
        component: () => import('@/views/pages/Category/Categories.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'categories/:id/edit',
        name: 'edit-category',
        component: () => import('@/views/pages/Category/EditCategory.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'categories/new',
        name: 'new-category',
        component: () => import('@/views/pages/Category/NewCategory.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/pages/Dashboard/Dashboard.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'faqs',
        name: 'faqs',
        component: () => import('@/views/pages/FAQ/FAQs.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'gm_faqs',
        name: 'gm',
        component: () => import('@/views/pages/GMFAQ/GMFAQs.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'faqs/:id/edit',
        name: 'edit-faq',
        component: () => import('@/views/pages/FAQ/EditFAQ.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'gm_faqs/:id/edit',
        name: 'edit-gm-faq',
        component: () => import('@/views/pages/GMFAQ/EditGMFAQ.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'faqs/new',
        name: 'new-faq',
        component: () => import('@/views/pages/FAQ/NewFAQ.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'gm_faqs/new',
        name: 'new-gm-faq',
        component: () => import('@/views/pages/GMFAQ/NewGMFAQ.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'dynamic_page/:id/edit',
        name: 'edit-dynamic-page',
        component: () => import('@/views/pages/DynamicPages/EditDynamicPage.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'sent_to_payroll_reminder',
        name: 'sent-to-payroll-reminder',
        component: () => import('@/views/pages/DynamicPages/SentToPayroll.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'bonus_schedule',
        name: 'bonus-schedule',
        component: () => import('@/views/pages/DynamicPages/BonusSchedule.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'international_bonus_schedule',
        name: 'international-bonus-schedule',
        component: () => import('@/views/pages/DynamicPages/IntlBonusSchedule.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'training_guide',
        name: 'training-guide',
        component: () => import('@/views/pages/DynamicPages/TrainingGuideVideo.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: 'export/:id',
        name: 'export',
        component: () => import('@/views/pages/Export/Export.vue'),
        meta: {
          roles: ['Admin'],
        },
      },
      {
        path: '/notfound',
        name: 'notfound',
        component: () => import('@/views/pages/NotFound.vue'),
        meta: {
          roles: [],
        },
      },
      {
        path: '/unauthorized',
        name: 'unauthorized',
        component: () => import('@/views/pages/Unauthorized.vue'),
        meta: {
          roles: [],
        },
      },
      {
        path: '/no_dashboard_access',
        name: 'no-dashboard-access',
        component: () => import('@/views/pages/NoDashboardAccess.vue'),
        meta: {
          roles: ['Corporate Accounting', 'MBUP', 'Strategic Account'],
        },
      },
    ],
  },
  {
    path: '/sign_in',
    name: 'sign_in',
    component: () => import('@/views/pages/SignIn.vue'),
    meta: {
      roles: [],
    },
  },
  {
    path: '/forgot_password',
    name: 'forgot_password',
    component: () => import('@/views/pages/ForgotPassword.vue'),
    meta: {
      roles: [],
    },
  },
  {
    path: '/reset_password',
    name: 'reset_password',
    component: () => import('@/views/pages/ResetPassword.vue'),
    meta: {
      roles: [],
    },
  },
  {
    path: '/health-check',
    name: 'health-check',
    component: () => import('@/views/pages/HealthCheck.vue'),
    meta: {
      roles: [],
    },
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('@/views/pages/Maintenance.vue'),
    meta: {
      roles: [],
    },
  },
];
